export interface CadastroDocument {
  id: string;
  nome_completo: string;
  data_nascimento?: string;
  cpf?: string;
  cnpj?: string;
  telefone?: string;
  ops?: string;
  ifood_uuid?: string;
  nao_aprovado_azumi?: boolean;
  tipo_emissao_nf?: string;
  chave_pix?: string;
  tipo_chave_pix?: string;
  tipo_titularidade_pix?: string;
  gateway_pagamento?: string;
  service_city?: ServiceCity;
  created_at?: string;
  // bloqueio vigente da linha (do documento na ops ou só do telefone)
  bloqueio_id?: number | null;
  bloqueio_telefone?: string | null;
  bloqueio_origem?: BloqueioOrigem | null;
  bloqueio_motivo_codigo?: string | null;
  bloqueio_motivo_texto?: string | null;
  bloqueio_criado_por?: string | null;
  bloqueio_criado_em?: string | null;
}

export interface SearchCadastroParams {
  dbName: string;
  telefone?: string;
  cpf?: string;
  cnpj?: string;
}

export interface SearchCadastroResponse {
  cadastro: CadastroDocument[];
  allOps: Array<{ ops: string }>;
}

export interface UpdateCadastroParams {
  dbName: string;
  id: string;
  nome_completo?: string;
  data_nascimento?: string;
  cnpj?: string;
  ops?: string;
  ifood_uuid?: string;
  gateway_pagamento?: string;
  service_city?: ServiceCity;
}

export interface CadastroEditFormData {
  nome_completo: string;
  data_nascimento: string;
  cnpj: string;
  ops: string;
  ifood_uuid: string;
  gateway_pagamento: string;
  service_city: ServiceCity;
}

export const GATEWAYS_PAGAMENTO = ["fitbank", "transfeera"] as const;

/** Município do serviço na NFS-e (doc_cadastro_wts.service_city, default 'emissor'). */
export type ServiceCity = "emissor" | "tomador";

export interface CadastroSearchFormData {
  telefone: string;
  cpfCnpj: string;
}

// ─── Bloqueio (bloqueio_entregador, via /gestorBloqueio) ─────────────────────

export type BloqueioOrigem = "gestor" | "cliente";
export type BloqueioStatusFiltro = "vigente" | "revogado" | "todos";

export interface BloqueioMotivo {
  codigo: string;
  rotulo: string;
  exigeTelefone?: boolean;
}

export interface BloqueioOpcoes {
  motivos: BloqueioMotivo[];
  ops: string[];
}

export interface Bloqueio {
  id: number;
  numero_documento: string;
  ops: string;
  telefone: string | null;
  origem: BloqueioOrigem;
  motivo_codigo: string | null;
  motivo_texto: string | null;
  lote_id: string | null;
  criado_em: string;
  criado_por: string;
  revogado_em: string | null;
  revogado_por: string | null;
  revogado_origem: BloqueioOrigem | null;
  revogado_motivo: string | null;
  nome_completo: string | null;
}

export interface BloqueioFiltros {
  ops_entregador?: string;
  origem?: BloqueioOrigem;
  motivo_codigo?: string;
  status?: BloqueioStatusFiltro;
  documento?: string;
}

export interface ListarBloqueiosResponse {
  items: Bloqueio[];
  motivos: BloqueioMotivo[];
  pagination: {
    page: number;
    pageSize: number;
    totalRows: number;
    totalPages: number;
  };
}

export interface BloquearParams {
  documentos: string[];
  ops_entregador: string;
  telefone?: string;
  motivo_codigo?: string;
  motivo_texto?: string;
}

export interface DesbloquearParams {
  ids?: number[];
  documentos?: string[];
  ops_entregador?: string;
  revogado_motivo?: string;
}

export interface BloqueioResultado {
  success: Array<string | number>;
  failed: Array<{ documento?: string; id?: number; reason: string }>;
  avisos: Array<{ documento: string; reason: string }>;
}
